import { render, staticRenderFns } from "./404-page.vue?vue&type=template&id=d738ada4&scoped=true&"
var script = {}
import style0 from "./404-page.vue?vue&type=style&index=0&id=d738ada4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d738ada4",
  null
  
)

export default component.exports